import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import Icon from './icon/Icon';
import Input from './bootstrap/forms/Input';
import Modal, { ModalBody, ModalHeader } from './bootstrap/Modal';
import { componentsMenu } from '../menu';
import ProjectService from '../services/ProjectService';

const Search = () => {
	const refSearchInput = useRef(null);
	const navigate = useNavigate();
	const [searchModalStatus, setSearchModalStatus] = useState(false);
	const [items, setItems] = useState([])
	const formik = useFormik({
		initialValues: {
			searchInput: '',
		},
		// eslint-disable-next-line no-unused-vars
		onSubmit: (values) => {
			setSearchModalStatus(true);
		},
	});

	const getIcon = (type) => {
		return "File"
	}


	useEffect(async () => {
		const projects = (await ProjectService.getProjects())?.map(p => ({ ...p, type: "project", path: `dealdashboard/${p?._id}` }))
		setItems(projects)

		const files = await ProjectService.getProjects()

	}, [])


	useEffect(() => {
		if (formik.values.searchInput) {
			setSearchModalStatus(true);
			refSearchInput?.current?.focus();
		}
		return () => {
			setSearchModalStatus(false);
		};
	}, [formik.values.searchInput]);

	const filterResult = items?.filter(
		(item) =>
			item?.title?.toString()?.toLowerCase()?.includes(formik.values?.searchInput?.toLowerCase())
	)
	return (
		<>
			<div className='d-flex' data-tour='search'>
				<label className='border-0 bg-transparent cursor-pointer' htmlFor='searchInput'>
					<Icon icon='Search' size='2x' color='primary' />
				</label>
				<Input
					id='searchInput'
					type='search'
					className='border-0 shadow-none bg-transparent'
					placeholder='Search...'
					onChange={formik.handleChange}
					value={formik.values.searchInput}
					autoComplete='off'
				/>
			</div>
			<Modal
				setIsOpen={setSearchModalStatus}
				isOpen={searchModalStatus}
				isStaticBackdrop
				isScrollable
				data-tour='search-modal'>
				<ModalHeader setIsOpen={setSearchModalStatus}>
					<label className='border-0 bg-transparent cursor-pointer' htmlFor='searchInput'>
						<Icon icon='Search' size='2x' color='primary' />
					</label>
					<Input
						ref={refSearchInput}
						name='searchInput'
						className='border-0 shadow-none bg-transparent'
						placeholder='Search...'
						onChange={formik.handleChange}
						value={formik.values.searchInput}
					/>
				</ModalHeader>
				<ModalBody>
					<table className='table table-hover table-modern caption-top mb-0'>
						<caption>Results: {filterResult.length}</caption>
						<thead className='position-sticky' style={{ top: -13 }}>
							<tr>
								<th scope='col'>Pages</th>
							</tr>
						</thead>
						<tbody>
							{filterResult.length ? (
								filterResult.map((item) => (
									<tr
										key={item.id}
										className='cursor-pointer'
										onClick={() => {
											formik.setFieldValue('searchInput', "")
											navigate(`../${item.path}`);
										}}>
										<td>
											{item.type && (
												<Icon
													icon={getIcon(item.type)}
													size='lg'
													className='me-2'
													color='primary'
												/>
											)}
											{item.title}
										</td>
									</tr>
								))
							) : (
								<tr className='table-active'>
									<td>No result found for query "{formik.values.searchInput}"</td>
								</tr>
							)}
						</tbody>
					</table>
				</ModalBody>
			</Modal>
		</>
	);
};

export default Search;
